<template>
	<div>
		<!-- 出勤天数 -->
		<Popup
			v-model="attendance_display"
			title="出勤天数"
			@confirmClick="handleAttendanceConfirmClick"
		>
			<div v-loading="attendance_loading" style="padding: 15px;">
				<el-calendar v-model="date">
					<template
						slot="dateCell"
						slot-scope="{date, data}"
					>
						<p v-if="days.indexOf(data.day) != -1 && abnormal_days.indexOf(data.day) != -1" style="height: 100%;padding: 10px;color: #f00;" @click="handleAbnormalDayClick(data.day)">{{ data.day.split('-').slice(1).join('-') }}</p>
						<p v-if="days.indexOf(data.day) != -1 && abnormal_days.indexOf(data.day) == -1" style="height: 100%;padding: 10px;color: #409EFF;" @click="handleAbnormalDayClick(data.day)">{{ data.day.split('-').slice(1).join('-') }}</p>
						<p v-if="days.indexOf(data.day) == -1 && abnormal_days.indexOf(data.day) == -1" style="height: 100%;padding: 10px;">{{ data.day.split('-').slice(1).join('-') }}</p>
					</template>
				</el-calendar>
			</div>
		</Popup>
		<!-- 出勤天数 end -->
		
		<!-- 当日训练详情 -->
		<Popup
			v-model="training_display"
			title="当日训练详情"
			@confirmClick="handleTrainingConfirmClick"
		>
			<div v-loading="training_loading" style="padding: 15px;">
				<!-- 表格 -->
				<div class="base_table">
					<el-table
						:data="training_data"
						style="width: 100%"
					>
						<el-table-column
							prop="time"
							label="训练时间"
						>
						</el-table-column>
						<el-table-column
							prop="taskName"
							label="任务名称"
						>
						</el-table-column>
						<el-table-column
							label="训练时长(分钟)"
						>
							<template slot-scope="scope">
								<span v-if="scope.row.isException && (scope.row.taskTime < 7 || scope.row.taskTime > 14)" style="color: #f00;">{{ scope.row.useTime }}</span>
								<span v-if="!scope.row.isException || (scope.row.taskTime >= 7 && scope.row.taskTime <= 14)">{{ scope.row.useTime }}</span>
							</template>
						</el-table-column>
						<el-table-column
							label="准确率(%)"
						>
							<template slot-scope="scope">
								<span 
									v-if="scope.row.isException && scope.row.rate < 65" 
									style="cursor: pointer;color: #f00;text-decoration: underline;"
									@click="handleCorrectionClick(scope.row)"
								>{{ scope.row.rate }}</span>
								<span 
									v-if="!scope.row.isException || scope.row.rate >= 65"
									style="cursor: pointer;text-decoration: underline;"
									@click="handleCorrectionClick(scope.row)"
								>{{ scope.row.rate }}</span>
							</template>
						</el-table-column>
						<el-table-column
							label="完成度(%)"
						>
							<template slot-scope="scope">
								<span v-if="scope.row.isException && scope.row.finish < 100" style="color: #f00;">{{ scope.row.finish }}</span>
								<span v-if="!scope.row.isException || scope.row.finish >= 100">{{ scope.row.finish }}</span>
							</template>
						</el-table-column>
						<el-table-column
							prop="comment"
							label="认真度"
						>
						</el-table-column>
					</el-table>
				</div>
				<!-- 表格 end -->
			</div>
		</Popup>
		<!-- 当日训练详情 end -->
		
		<!-- 难度指标 -->
		<Popup
			v-model="correctionDisplay"
			title="难度指标"
			:confirmBtnDisplay="false"
		>
			<div v-loading="correctionLoading" style="padding: 15px;">
				<p v-if="false" style="text-indent: 2em;">若该用户训练任务难度异常，可能是因为训练过程中未按照要求努力辨认训练图片、训练距离异常、训练环境高度过高等造成。</p>
				<p v-if="false" style="text-indent: 2em;">如有需要，请点击下方“重置任务难度”按钮，明天将为用户重新设置训练任务难度，请叮嘱用户认真训练。</p>
				<div class="com_correction_box">
					<!-- <div class="in_top">
						<div class="in_question" @click="handleExplainClick"><i class="el-icon-question"></i>查看说明</div>
					</div> -->
					<div ref="correction_chart" style="height: 350px;"></div>
				</div>
			</div>
		</Popup>
		<!-- 难度指标 end -->
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js';
	import Echarts from "echarts";
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			uid: {
				type: [Number, String],
				required: true
			}
		},
		mounted() {
			this.correctionChartData = [];
			this.year = new Date().getFullYear();
			this.month = new Date().getMonth() + 1 < 10 ? `0${ new Date().getMonth() + 1 }` : (new Date().getMonth() + 1);
			this.display && (this.attendance_display = true);
		},
		data() {
			return {
				attendance_display: false,
				attendance_loading: false,
				date: new Date(),
				days: [],
				abnormal_days: [],
				training_display: false,
				training_loading: false,
				training_data: [],
				missionObj: {},
				correctionDisplay: false,
				correctionLoading: false
			}
		},
		methods: {
			/****************** @Events **********************/
			// 点击异常日历
			handleAbnormalDayClick(date) {
				this.getSingleTraining(date);
			},
			// 点击正确率
			handleCorrectionClick (data) {
				const that = this;
				this.missionObj = data;
				this.getCorrectionData(() => {
					// that.trainingDisplay = false;
					that.correctionDisplay = true;
					that.$nextTick(() => {
						that.createCorrectionEchart();
					});
				});
			},
			// 点击确定
			handleAttendanceConfirmClick() {
				this.attendance_display = false;
			},
			// 点击确定
			handleTrainingConfirmClick() {
				this.training_display = false;
			},
			/****************** @Function **********************/
			// 获取用户出勤率
			getAttendance() {
				const that = this;
				that.attendance_loading = true;
				let requestData = { 
					time: `${ that.year }-${ that.month }`,
					userId: that.uid
				};
				Api.findAttendanceByUser(requestData).then((res) => {
					if (res.data.success) {
						that.days = res.data.data || [];
						that.getAbnormalAttendance();
					} else {
						that.attendance_loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.attendance_loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取用户异常出勤日
			getAbnormalAttendance() {
				const that = this;
				let requestData = { 
					time: `${ that.year }-${ that.month }`,
					userId: that.uid
				};
				Api.findAbnormalAttendanceByUser(requestData).then((res) => {
					that.attendance_loading = false;
					if (res.data.success) {
						that.abnormal_days = res.data.data || [];
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.attendance_loading = false;
					that.$message.error(e.message);
				});
			},
			// 查询用户当日训练
			getSingleTraining(date) {
				const that = this;
				that.attendance_loading = true;
				let requestData = { 
					selectTime: date,
					userId: that.uid
				};
				Api.findSingleTrainingByDate(requestData).then((res) => {
					that.attendance_loading = false;
					if (res.data.success) {
						let data = [];
						res.data.data.forEach((v) => {
							data.push({
								missionId: v.missionId,
								missionRecId: v.missionRecId,
								time: v.yestodayTime,
								taskName: v.missionName,
								taskTime: Math.ceil(v.missionUseTime / (v.missionFinishRate / 100) / 60),
								useTime: Math.ceil(v.missionUseTime / 60),
								rate: v.missionRec,
								finish: v.missionFinishRate,
								comment: v.missionComment,
								isException: v.missionId != 300 && v.missionId != 301 && v.missionId != 302 && v.missionId != 303
							});
						});
						that.training_data = data;
						that.training_display = true;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.attendance_loading = false;
					that.$message.error(e.message);
				});
			},
			// 请求正确率数据
			getCorrectionData(callBack) {
				const that = this;
				that.training_loading = true;
				var requestData = {
					missionRecId: that.missionObj.missionRecId
				};
				Api.findUserCorrectRate(requestData).then((res) => {
					that.training_loading = false;
					if (res.data.success) {
						that.correctionChartData = res.data.data.length ? res.data.data : [];
						that.correctionEchart && that.correctionEchart.dispose();
						callBack && callBack();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.training_loading = false;
					that.$message.error(e.message);
				});
			},
			// 生成正确率折线图
			createCorrectionEchart () {
				var xData = [],
					seriesData = [],
					xIndex = 0;
				for (var index = this.correctionChartData.length - 1;index >= 0;index--) {
					xData.push(++xIndex);
					seriesData.push(this.correctionChartData[index].level || 0);
				}
				this.correctionEchart = Echarts.init(this.$refs.correction_chart);
				var option = {
					dataZoom: [{
						type: 'inside',
						start: 0,
						end: 100
					}, {
						start: 0,
						end: 100,
						handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
						handleSize: '80%',
						handleStyle: {
							color: '#fff',
							shadowBlur: 3,
							shadowColor: 'rgba(0, 0, 0, 0.6)',
							shadowOffsetX: 2,
							shadowOffsetY: 2
						}
					}],
					tooltip: {
						trigger: 'axis'
					},
					grid: {
						show: false,
						right: 20
					},
					xAxis: {
						type: 'category',
						data: xData,
						boundaryGap: false
					},
					yAxis: {
						name: '难度指标'
						// boundaryGap: [0, '100%']
					},
					series: [{
						name: '难度指标',
						type: 'line',
						smooth: false,
						symbolSize: 5,
						data: seriesData,
						areaStyle: {
							color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgb(255, 158, 68)'
							}, {
								offset: 1,
								color: 'rgb(255, 70, 131)'
							}])
						},
						sampling: 'average',
						itemStyle: {
							color: 'rgb(255, 70, 131)'
						}
					}]
				};
				this.correctionEchart.setOption(option);
			}
		},
		watch: {
			display(newVal) {
				this.attendance_display = newVal;
			},
			attendance_display(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.getAttendance();
				} else {
					this.year = new Date().getFullYear();
					this.month = new Date().getMonth() + 1 < 10 ? `0${ new Date().getMonth() + 1 }` : (new Date().getMonth() + 1);
					this.attendance_loading = false;
					this.date = new Date();
					this.days = [];
					this.abnormal_days = [];
				}
			},
			training_display(newVal) {
				if (!newVal) {
					this.training_loading = false;
					this.training_data = [];
				}
			},
			correctionDisplay(newValue) {
				if (!newValue) {
					this.correctionChartData = [];
					this.missionObj = {};
					this.correctionLoading = false;
					this.correctionEchart && this.correctionEchart.dispose();
				}
			},
			date(newVal) {
				let year = new Date(newVal).getFullYear();
				let month = new Date(newVal).getMonth() + 1 < 10 ? `0${ new Date(newVal).getMonth() + 1 }` : (new Date(newVal).getMonth() + 1);
				if (year != this.year || month != this.month) {
					this.year = year;
					this.month = month;
					this.getAttendance();
				}
			}
		}
	}
</script>

<style>
</style>
